export default defineNuxtPlugin(async (nuxtApp) => {
    const Swiper = await import('swiper')
    nuxtApp.vueApp.directive('swiper', {
        mounted(el, binding, vnode, prevVnode) {
            const swiper = new Swiper(el, binding.value)
            swiper.update()
        },
        created(el, binding, vnode, prevVnode) {
            // 下面会介绍各个参数的细节
            // console.log("createedSwiper", binding)
        },
        updated(el, binding, vnode, prevVnode) {
            const swiper = el.swiper||new Swiper(el, binding.value)
            swiper.update()
        },
        getSSRProps(binding, vnode) {
            // you can provide SSR-specific props here
            return {}
        }
    })
})